﻿import { ajaxGet, toFullQuery } from '../utils/ajax';

let cache = {};

function getSuggestions(query, caretPosition, hasStreetName, addressId, callback, errorCallback) {
    if (!query.length) {
        return false;
    }

    let params = {};
    params.q = query;
    params.fuzzy = '';
    params.type = 'adresse';
    params.caretpos = caretPosition;
    params.per_side = 100;

    let zip = /(\d{4})/g.exec(query);
    if (zip !== null) {
        zip = zip[0];
    } else {
        zip = false;
    }

    if (addressId) {
        params.adgangsadresseid = addressId;
    }

    if (hasStreetName) {
        params.startfra = 'adgangsadresse';
    }

    if (zip) {
        params.postnr = zip;
    }

    const paramsString = JSON.stringify(params);
    if (cache[paramsString]) {
        return callback(cache[paramsString]);
    }

    const url = toFullQuery('https://dawa.aws.dk/autocomplete', params);

    setTimeout(() => {
        ajaxGet(url)
            .then((json) => {
                if (!json) {
                    errorCallback();
                }

                const data = JSON.parse(json);
                const addresses = data.map((s) => {
                    return {
                        friendly: s.forslagstekst,
                        type: s.type,
                        caretposition: s.caretpos,

                        id: s.data.id,
                        streetName: s.data.vejnavn,
                        streetNumber: s.data.husnr,
                        floorNumber: s.data.etage || '',
                        floorSide: s.data.dør || '',
                        postCode: s.data.postnr,
                        city: s.data.postnrnavn
                    };
                });

                cache[paramsString] = addresses;

                callback(addresses);
            })
            .catch(errorCallback);
    }, 100);
}

export { getSuggestions};
